/**
 * 字典
 */
export default {
	// 婚姻状态
	maritalStates: [
		{label: '单身', value: 1},	
		{label: '恋爱中', value: 2},	
		{label: '离异', value: 3},	
		{label: '丧偶', value: 4},	
		{label: '已婚', value: 5},	
		{label: '保密', value: 6},	
	],
	
	// 学历
	qualification: [
		{label: '小学', value: 1},	
		{label: '初中', value: 2},	
		{label: '中专', value: 3},	
		{label: '高中', value: 4},	
		{label: '大专', value: 5},	
		{label: '本科', value: 6},	
		{label: '硕士', value: 7},	
		{label: '博士', value: 8},	
	],
	
	// 收入
	income: [
		{label: '5w以下', value: 1},	
		{label: '5-10万', value: 2},	
		{label: '10-20万', value: 3},	
		{label: '20-30万', value: 4},	
		{label: '30-50万', value: 5},	
		{label: '50-100万', value: 6},	
		{label: '100万以上', value: 7},	
	],

	// 金币
	gold: [
		{label: '充值', value: 1},	
		{label: '提现', value: 2},	
		{label: '注册奖励', value: 3},	
		{label: '购买产品赠送', value: 4},	
		{label: '发消息', value: 5},	
		{label: '送礼物', value: 6},	
		{label: '语言', value: 7},	
		{label: '视频', value: 8},	
		{label: '对方未回复消息退还', value: 9},
		{label: '签到奖励', value: 10},
		{label: '后台调整', value: 11},
	],

	// 积分
	score: [
		{label: '回复消息', value: 1},	
		{label: '接听语音电话', value: 2},	
		{label: '接听视频电话', value: 3},	
		{label: '收到礼物', value: 4},	
		{label: '注册奖励', value: 5},	
		{label: '邀请分润', value: 6},
		{label: '兑换支出', value: 7},
		{label: '签到', value: 8},
	],

	violateType: [
		{label: '色情', value: 1},
		{label: '低俗', value: 2},
		{label: '辱骂', value: 3},
		{label: '政治', value: 4},
		{label: '暴力血腥', value: 5},
		{label: '违法与涉毒', value: 6},
		{label: '仇恨与歧视', value: 7},
		{label: '其他', value: 8},
	],
}


